import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("afrigo_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const LOGO = "https://static.prod-images.emergentagent.com/jobs/86030160-e8c5-4934-9154-f9a654fd769a/images/8be1868d9116e2a13be46da9c0374fdc17cb55232ae16eae174d1c4f5d978080.jpeg";

export const BANNERS = [
  { img: "https://images.unsplash.com/photo-1613061445510-e296bfedb73e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", kicker: "From the Homeland", title: "Style that carries the sun of Africa", sub: "Dresses, ankara, sneakers & more, delivered to your door across the continent.", cta: "clothing" },
  { img: "https://images.unsplash.com/photo-1746171114403-f4c4877b1f04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", kicker: "The Big Market", title: "The whole market, in your pocket", sub: "3,000+ products. Pay with M-Pesa, EcoCash, MoMo, PayPal or card.", cta: "fashion" },
  { img: "https://images.unsplash.com/photo-1631646109206-4b5616964f84?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", kicker: "Village to City", title: "We deliver where the road goes", sub: "Appliances & home essentials shipped from town to village.", cta: "home" },
];

export const CATEGORY_IMAGES = {
  clothing: "https://images.unsplash.com/photo-1563132337-f159f484226c?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  fashion: "https://images.unsplash.com/photo-1708170236295-20ab8fbadcef?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  makeup: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  appliances: "https://images.unsplash.com/photo-1618506408870-64d8bec48248?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  home: "https://images.unsplash.com/photo-1615529182904-14819c35db37?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  electronics: "https://images.unsplash.com/photo-1741851547702-cac24b2a0d13?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  kids: "https://images.unsplash.com/photo-1485110168560-69d4ac37b23e?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  sports: "https://images.unsplash.com/photo-1726195225009-56c724665a49?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
};

export const CURRENCIES = {
  USD: { symbol: "$", rate: 1 },
  KES: { symbol: "KSh ", rate: 129.5 },
  ZAR: { symbol: "R ", rate: 18.2 },
  NGN: { symbol: "₦", rate: 1480 },
  GHS: { symbol: "GH₵ ", rate: 15.4 },
};

export const PAYMENT_METHODS = [
  { id: "mpesa", name: "M-Pesa", desc: "STK push to your Safaricom phone", color: "#1E8E3E" },
  { id: "ecocash", name: "EcoCash", desc: "Zimbabwe mobile wallet", color: "#1D4ED8" },
  { id: "momo", name: "MTN MoMo", desc: "Ghana, Uganda, Rwanda, Cameroon", color: "#EAB308" },
  { id: "airtel", name: "Airtel Money", desc: "Kenya, Uganda, Zambia, Malawi", color: "#E40000" },
  { id: "paypal", name: "PayPal", desc: "Pay with your PayPal balance", color: "#0070BA" },
  { id: "stripe", name: "Card (Visa / Mastercard)", desc: "Secure checkout by Stripe", color: "#C85A32" },
  { id: "flutterwave", name: "Flutterwave / Bank", desc: "Bank transfer, USSD, Airtel Money", color: "#F59E0B" },
];
